import { Layout, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import EventImg from "../../../../assets/images/live-fight-event/image-event-03-05.webp";
import ArrowLeftIconComponent from "../../../../components/ArrowLeftIconComponent";
import InfoTicketLiveEventComponent from "../../../../components/LiveEventComponent/InfoTicketLiveEventComponent";
import SpinnerComponent from "../../../../components/SpinnerComponent/SpinnerComponent";
import useFetchRTMPStream from "../../../../hooks/userHooks/useFetchRTMPStream";
import "./index.less";

const FanLiveEventTicketPage = () => {
  const navigate = useNavigate();
  const { rtmpLive, rtmpLiveLoading } = useFetchRTMPStream();

  const reserveTicket = () => {
    navigate("/common/event-payment");
  };

  // const handleNavigateToPaymentPage = () => {
  //   Cookies.remove("ffe");
  //   navigate("/common/event-payment");
  //   console.log("inside handleNavigateToPaymentPage ==========> return null");
  //   return null;
  // };

  return (
    <Spin spinning={rtmpLiveLoading} style={{ maxHeight: "100%" }} indicator={<SpinnerComponent />}>
      <Layout>
        {/* {rtmpLive && !rtmpLive.isPaymentVerified && Cookies.get("ffe") ? (
          handleNavigateToPaymentPage()
        ) : ( */}
        <Layout.Content className="event-ticket-wrapper">
          <ArrowLeftIconComponent top={20} left={15} navigateTo="/p/fan/lives?schedule" />
          <img className="event-img" src={EventImg} alt="Fight" />
          <InfoTicketLiveEventComponent connected={true} alreadyReserved={!!rtmpLive?.isPaymentVerified} onButtonClick={reserveTicket} />
        </Layout.Content>
        {/* )} */}
      </Layout>
    </Spin>
  );
};

export default FanLiveEventTicketPage;
